import '../../../ProductCard/ProductCard.scss';
import './Wrapper.scss';

import classnames from 'classnames';
import React, { useContext } from 'react';

import { useTheme } from '../../../../hooks/useTheme';
import TRANSLATIONS from '../../../../translations/translations@default.json';
import { Context } from '../../store/store';
import Wrapper from './Wrapper';

const AoLovesMobileWrapper = ({ product, index }) => {
	const [state] = useContext(Context);
	const { loaded } = state;

	const theme = useTheme('aoLoves');

	const props = {
		top: '-170px',
		left: '-110px',
	};

	return (
		<li
			id={product.Code}
			className={classnames(
				'relative flex flex-col h-full w-full px-1 pb-1 xs:px-2 xs:pb-2 sm:px-4 sm:pb-4 m-2 sm:mx-0 mobileCard__wrapper overflow-hidden rounded',
				theme.background,
				{ 'bg-gray-20': !loaded }
			)}
			style={{
				WebkitTransform: 'translateZ(0)',
				backgroundImage: theme.mobileBackground,
				backgroundSize: 'cover',
			}}
			itemProp="itemListElement"
			itemScope
			itemType="http://schema.org/ListItem">
			<meta itemProp="position" content={index} />
			<div className="flex">
				<div className="ico ico-ao-loves text-white py-4 text-xl mr-2"></div>
				<div
					className={classnames('text-title-lg py-4', {
						[`${theme.text}`]: loaded,
						'text-gray-20': !loaded,
					})}>
					AO Loves
				</div>
			</div>

			<Wrapper {...{ product, index, isFeatured: true }} />
		</li>
	);
};

export default AoLovesMobileWrapper;
